import Aos from 'aos'
import './_frontend.scss'
import Sidebar from 'components/sidebar'
import { useStateContext } from 'context/StateContext'
import { useEffect, useRef } from 'react'
import MainContent from 'pages/frontend/main-content/Routes'
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined'
import KeyboardArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardArrowLeftOutlined'
import buttonSound from 'assets/sounds/mouse-click.mp3'
import buttonSound1 from 'assets/sounds/mouse-click2.mp3'

export default function Index() {
  const { handleNextPage, buttonSoundRef, buttonSoundRef1, pages } = useStateContext()
  const divRef = useRef()

  useEffect(() => { Aos.init({ duration: 600, once: true }) }, [])
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { divRef.current?.scrollTo(0, 0) }, [window.location.pathname])

  return (
    <>
      <audio src={buttonSound} ref={buttonSoundRef} />
      <audio src={buttonSound1} ref={buttonSoundRef1} />

      <div className="container-fluid main-screen p-0 p-md-2 p-lg-3">
        {/* mobile top navbar */}
        <div className="d-block d-md-none">
          <Sidebar />
        </div>

        <div className="row mx-0" style={{ flex: 1 }}>
          {/* desktop sidebar */}
          <div className="p-0 sidebar-col rounded-4 d-none d-md-flex flex-column" data-aos="fade-right">
            <Sidebar />
          </div>

          {/* main content */}
          <div
            ref={divRef}
            className="col rounded-4 ms-0 ms-md-2 ms-lg-3 px-0 main-content"
          >
            <MainContent />
          </div>
        </div>

        {/* mobile prev/next buttons */}
        <div className="bottom-buttons d-flex d-md-none">
          <button
            className="nav-btn"
            disabled={window.location.pathname === pages[0]}
            onClick={() => handleNextPage('previous')}
          >
            <KeyboardArrowLeftOutlinedIcon fontSize="small" />
          </button>
          <button
            className="nav-btn"
            disabled={window.location.pathname === pages[pages.length - 1]}
            onClick={() => handleNextPage('next')}
          >
            <KeyboardArrowRightOutlinedIcon fontSize="small" />
          </button>
        </div>
      </div>
    </>
  )
}
